import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelfAssessmentLinkComponent } from './self-assessment-link/self-assessment-link.component';
import { SelfAssessmentComponent } from './self-assessment/self-assessment.component';

const routes: Routes = [
     {
                      path:'',component:SelfAssessmentLinkComponent,
                      children:[
                        {
                          path:"selfAssessment", component:SelfAssessmentComponent
                        },  
                      ]
                    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelfAssessmentRoutingModule { }
